// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"regions_wrapper__8JqbN","region_link":"regions_region_link__6hN3B","cities_link":"regions_cities_link__4ApxY"};